var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c(
            "el-row",
            [
              _c("task-table-view", {
                attrs: { title: _vm.$t("Latest Tasks") }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("el-col", { attrs: { span: 12 } }, [_c("spider-info-view")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }